export var GET_POPUP = '[Profile] Get Popup';
export var GET_POPUP_SUCCESS = '[Profile] Get Popup Success';
export var GET_POPUP_ERROR = '[Profile] Get Popup Error';
export var UPDATE_PROFILE_DETAILS = '[Profile] Update Profile Details';
export var UPDATE_PROFILE_DETAILS_SUCCESS = '[Profile] Update Profile Details Success';
export var UPDATE_PROFILE_DETAILS_ERROR = '[Profile] Update Profile Details Error';
var GetPopup = /** @class */ (function () {
    function GetPopup(payload) {
        this.payload = payload;
        this.type = GET_POPUP;
    }
    return GetPopup;
}());
export { GetPopup };
var GetPopupSuccess = /** @class */ (function () {
    function GetPopupSuccess(payload) {
        this.payload = payload;
        this.type = GET_POPUP_SUCCESS;
    }
    return GetPopupSuccess;
}());
export { GetPopupSuccess };
var GetPopupError = /** @class */ (function () {
    function GetPopupError(payload) {
        this.payload = payload;
        this.type = GET_POPUP_ERROR;
    }
    return GetPopupError;
}());
export { GetPopupError };
var UpdateProfileDetails = /** @class */ (function () {
    function UpdateProfileDetails(payload) {
        this.payload = payload;
        this.type = UPDATE_PROFILE_DETAILS;
    }
    return UpdateProfileDetails;
}());
export { UpdateProfileDetails };
var UpdateProfileDetailsSuccess = /** @class */ (function () {
    function UpdateProfileDetailsSuccess(payload) {
        this.payload = payload;
        this.type = UPDATE_PROFILE_DETAILS_SUCCESS;
    }
    return UpdateProfileDetailsSuccess;
}());
export { UpdateProfileDetailsSuccess };
var UpdateProfileDetailsError = /** @class */ (function () {
    function UpdateProfileDetailsError(payload) {
        this.payload = payload;
        this.type = UPDATE_PROFILE_DETAILS_ERROR;
    }
    return UpdateProfileDetailsError;
}());
export { UpdateProfileDetailsError };



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/profile/store/actions/profile.action.ts.pre-build-optimizer.js